import { CanActivateFn } from '@angular/router';

export const AuthGuard: CanActivateFn = (route, state) => {
  // TODO: Implement logic to handle authenticated state
  return true;
};
